module.exports = __webpack_public_path__ + "img/ic_check_base.b3220596.svg";